import { render, staticRenderFns } from "./StoreCostConfig.vue?vue&type=template&id=312dde30&scoped=true"
import script from "./StoreCostConfig.vue?vue&type=script&lang=js"
export * from "./StoreCostConfig.vue?vue&type=script&lang=js"
import style0 from "./StoreCostConfig.vue?vue&type=style&index=0&id=312dde30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312dde30",
  null
  
)

export default component.exports